import { combineReducers } from 'redux';
import reducer from './reducer';
import eventsReducer from './eventsReducer'

const rootReducer = combineReducers({
    reducer, eventsReducer
});

export default rootReducer;

